import authReducer from './reducers';

export { default as authActions } from './actions';
export { default as authSelectors } from './selectors';

export default authReducer;
